import React from "react";
import { MrbPage } from "mrb/components/layout";
import PropTypes from "prop-types";
import { defaultTemplate } from "common/hoc";
import { MrbRouterLink } from "mrb/core/infrastructure/router";
import { mergeCss } from "mrb/common/utils";

function NakiMobileHomeScreenTemplate({ nakiMobileHomeScreenViewStore, renderChildRoute, t, ...props }) {
    const { selectedTab, setSelectedTab } = nakiMobileHomeScreenViewStore;

    return (
        <React.Fragment>
            <MrbPage>
                <div className="c-tabs">
                    <React.Fragment>
                        <MrbRouterLink
                            onClick={() => setSelectedTab(1)}
                            className={mergeCss(
                                "c-tabs__item",
                                selectedTab.title === "mobile" && "c-tabs__item--active"
                            )}
                            routeName="master.administration.naki-mobile.sections.mobile"
                        >
                            {t("ADMINISTRATION.NAKI_MOBILE.HOME_SCREEN.MOBILE.TITLE")}
                        </MrbRouterLink>
                        <MrbRouterLink
                            onClick={() => setSelectedTab(2)}
                            className={mergeCss(
                                "c-tabs__item",
                                selectedTab.title === "mobile_embedded" && "c-tabs__item--active"
                            )}
                            routeName="master.administration.naki-mobile.sections.mobile-embedded"
                        >
                            {t("ADMINISTRATION.NAKI_MOBILE.HOME_SCREEN.MOBILE_EMBEDDED.TITLE")}
                        </MrbRouterLink>
                        <MrbRouterLink
                            onClick={() => setSelectedTab(3)}
                            className={mergeCss(
                                "c-tabs__item",
                                selectedTab.title === "mobile_handheld" && "c-tabs__item--active"
                            )}
                            routeName="master.administration.naki-mobile.sections.mobile-handheld"
                        >
                            {t("ADMINISTRATION.NAKI_MOBILE.HOME_SCREEN.MOBILE_HANDHELD.TITLE")}
                        </MrbRouterLink>
                        <MrbRouterLink
                            onClick={() => setSelectedTab(4)}
                            className={mergeCss(
                                "c-tabs__item",
                                selectedTab.title === "mobile_handheld_pink" && "c-tabs__item--active"
                            )}
                            routeName="master.administration.naki-mobile.sections.mobile-handheld-pink"
                        >
                            {t("ADMINISTRATION.NAKI_MOBILE.HOME_SCREEN.MOBILE_HANDHELD_PINK.TITLE")}
                        </MrbRouterLink>
                    </React.Fragment>
                </div>

                {renderChildRoute(props)}
            </MrbPage>
        </React.Fragment>
    );
}

NakiMobileHomeScreenTemplate.propTypes = {
    nakiMobileHomeScreenViewStore: PropTypes.object.isRequired,
    renderChildRoute: PropTypes.func,
    t: PropTypes.func,
};

export default defaultTemplate(NakiMobileHomeScreenTemplate);
